import React, { useEffect, useState } from "react"
import { Container, Row, Col } from "react-bootstrap"
import accountbanner from "../../img/bannerimage.png"
import modalimage from "../../img/modalimage.png"
import "./account.css"
import signupimage from "../../img/signupimage.png"
import * as yup from "yup"
import { yupResolver } from "@hookform/resolvers/yup"
import { useForm } from "react-hook-form"
import { FormInput, FormSelect } from "../form"
import { COUNTRY_LIST } from "../../constants"
import { Form, Button } from "react-bootstrap"
import {
  useEditRegisterUserMutation,
  useGetRegisterUserQuery,
} from "../../services/authServices"
import { toast } from "react-toastify"
import { useNavigate } from "react-router-dom"
import { AiOutlineCamera } from "react-icons/ai"
import { values } from "lodash"
import { useAppSelector } from "../../app/hooks"

interface room1Props {}

interface AccountUser {
  firstName: string
  lastName: string
  email: string
  contactNo: string
  region: any
  address: string
}

interface FormSelectProps {
  // ... other properties
  defaultValue?: any
}

const Account = (props: room1Props) => {
  const [readOnly, setReadOnly] = useState(false)
  const [editButton, setEditButton] = useState("Edit")

  const [submitForm, { isError, error, data }] = useEditRegisterUserMutation()

  const schemaResolver = yupResolver(
    yup.object().shape({
      firstName: yup.string().required("Please enter name"),
      lastName: yup.string().required("Please enter last name"),
      email: yup.string().email().required("Please enter email"),
      contactNo: yup.string().required("Please enter a valid phone no"),
      region: yup.mixed().required("Please select a region"),
      address: yup.string().required("Please enter your address"),
    }),
  )
  const userProfile: any = useAppSelector((state: any) => state.profile)

  const user = userProfile.user

  const [initialState, setInitialState] = useState({
    firstName: user?.firstName,
    lastName: user?.lastName,
    email: user?.email,
    contactNo: user?.contactNo,
    region: { label: user?.region },
    address: user?.address,
  })

  const {
    register,
    control,
    handleSubmit,
    getValues,
    setValue,

    formState: { errors },
  } = useForm<AccountUser>({
    resolver: schemaResolver,
    defaultValues: initialState,
  })

  const onSubmit = async (values: any) => {
    const formdata = new FormData()

    formdata.append("firstName", values.firstName)
    formdata.append("lastName", values.lastName)
    formdata.append("email", values.email)
    formdata.append("contactNo", values.contactNo)
    formdata.append("address", values.address)
    formdata.append("region", values.region?.label)

    submitForm(formdata)
  }

  // useEffect(() => {
  //   if (data?.message) {
  //     setReadOnly(false)
  //   }
  // }, [error, data])

  const handleEdit = () => {
    if (editButton === "Edit") {
      setEditButton("Cancel")
      setReadOnly(true)
    } else if (editButton === "Cancel") {
      setReadOnly(false)
      setEditButton("Edit")
    }
  }

  // useEffect(() => {
  //   if (error) {
  //     toast.error((error as any).data?.message, { toastId: 44 })
  //   }
  // }, [isError])

  useEffect(() => {
    if (data?.message) {
      toast.success(data?.message, { toastId: 1 })
    }
  }, [data])

  const regionData = COUNTRY_LIST.filter((item) => item.name === user?.region)

  console.log("regionData", regionData)

  return (
    <>
      <Container fluid>
        <section className="account-banner main-wrapper">
          {/* <div className="banner-image pt-0">
            <img src={accountbanner} />
          </div> */}
          <div className="banner-section"></div>
          <div>
            <div></div>
          </div>

          <Form onSubmit={handleSubmit(onSubmit)}>
            <div className="model-item d-md-flex">
              <div className="d-md-flex align-items-center gap-30">
                <div className="position-relative">
                  <div className="girl-image">
                    <img src={modalimage} />
                  </div>
                  <Form.Control
                    type="file"
                    className="d-none"
                    id="changeImage"
                  />
                  <label htmlFor="changeImage" className="camera-icon">
                    <span className="camera">
                      <AiOutlineCamera />
                    </span>
                  </label>
                </div>
                <div className="model-text">
                  <h1>{user?.firstName + " " + user?.lastName}</h1>
                  {user?.isAdmin && <p className="user-occp"> Admin</p>}
                </div>
              </div>
              <div className="create-button">
                {/* <Button
                  type={readOnly ? "submit" : "button"}
                  onClick={!readOnly ? () => setReadOnly(true) : () => null}
                  className="save-button"
                >
                  {readOnly ? "Save" : "Edit"}
                </Button> */}

                <Button
                  variant="transparent"
                  type={"submit"}
                  onClick={() => setReadOnly(false)}
                  className="save-button"
                >
                  Save
                </Button>

                <Button
                  variant="transparent"
                  onClick={handleEdit}
                  className="cancel-button"
                >
                  {editButton}
                </Button>
              </div>
            </div>
            <div className="signin-form">
              <div className="form-content">
                <div className="signup-form d-block">
                  <Row>
                    <Col md={6}>
                      <div className="w-100 mb-4">
                        <FormInput
                          className="signup-field"
                          name="firstName"
                          title="First Name"
                          register={register}
                          disabled={!readOnly}
                          errors={errors}
                        />
                      </div>
                    </Col>
                    <Col md={6}>
                      <div className="w-100 i-spece-two mb-4">
                        <FormInput
                          className="signup-field"
                          name="lastName"
                          title="Last Name"
                          placeholder="Last Name"
                          register={register}
                          disabled={!readOnly}
                          errors={errors}
                        />
                      </div>
                    </Col>
                  </Row>
                </div>
                <div className="emailform mb-4">
                  <FormInput
                    className="signup-field"
                    name="email"
                    title="Email ID"
                    placeholder="sample@sample.com"
                    register={register}
                    disabled={true}
                    errors={errors}
                  />
                </div>
                <div className="phonenumber2 mb-4">
                  <FormInput
                    className="signup-field"
                    name="contactNo"
                    title="Contact No"
                    placeholder="00000 00000"
                    register={register}
                    disabled={!readOnly}
                    errors={errors}
                  />
                </div>
                <div className="emailform mb-4 justify-content-between">
                  <FormSelect
                    name="region"
                    title="Region"
                    control={control}
                    options={COUNTRY_LIST.map((x) => ({
                      label: x.name,
                      value: x.code,
                    }))}
                    errors={errors}
                    disabled={!readOnly}
                    placeholder={"Please select a region"}
                  />
                </div>
                <div className="passwordform mb-4">
                  <FormInput
                    className="signup-field"
                    name="address"
                    title="Address"
                    placeholder="#ABC, #Street"
                    register={register}
                    disabled={!readOnly}
                    errors={errors}
                  />
                </div>
              </div>
            </div>
          </Form>
        </section>
      </Container>
    </>
  )
}

export default Account
